import type {Field} from './types';

export const validateFields = (fields: {[key: string]: Field}) => {
  let result = true;

  Object.keys(fields)
    .map(key => fields[key])
    .forEach(field => {
      if (!field?.validate()) {
        result = false;
      }
    });

  return result;
};
